import {htmlToPng} from './htmlToPng';

export const initiateTimeOutDownload = (
  index: number,
  listOfCanvas: HTMLDivElement[],
  fileName: string,
  onError: (error: unknown, message: string) => void,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  const recursiveCreateAndDownload = (index: number) => {
    index++;

    if (index <= listOfCanvas.length) {
      htmlToPng({node: listOfCanvas[index - 1], fileName, index, onError});
      initiateTimeOutDownload(index, listOfCanvas, fileName, onError, setLoading);
    }

    if (index === listOfCanvas.length) setLoading(false);
  };

  setTimeout(() => {
    recursiveCreateAndDownload(index);
  }, 3000);
};
